export default {
    carregando: false,
    items: [],
    submodulos: [],
    rotas: [],
    selecionado: {}
}